import * as React from 'react'

import { ListHeader } from '~/client/src/shared/components/ListHeader'

import { useResourcePickerContext } from '../ResourcePickerContext'
import PickerFilters from './PickerFilters'

interface IProps {
  // Field configuration edits defaults, so reset clears instead of restoring - to the
  // fallback grouping, for a resource that is always grouped.
  resetToEmpty?: boolean
}

const PickerToolbar: React.FC<IProps> = ({ resetToEmpty }) => {
  const {
    searchQuery,
    setSearchQuery,
    sortKey,
    initialSortKey,
    sortOrder,
    initialSortOrder,
    groupByKey,
    initialGroupByKey,
    noneGroupingKey,
    setGroupByKey,
    setSort,
    sortOptions,
    groupByOptions,
    quickFilters,
    allowNoneGrouping,
    fallbackGroupByKey,
  } = useResourcePickerContext()

  const toGroupValue = (key: string | null) =>
    key === noneGroupingKey ? null : key

  return (
    <ListHeader.DisplayBar
      search={{ value: searchQuery, onChange: setSearchQuery }}
      quickFilters={
        quickFilters && {
          isOnlyMe: quickFilters.isOnlyMe,
          isOnlyMyCompany: quickFilters.isOnlyMyCompany,
          onToggleMe: quickFilters.toggleOnlyMe,
          onToggleMyCompany: quickFilters.toggleOnlyMyCompany,
          isMeDisabled: !quickFilters.hasUserProperties,
          isMyCompanyDisabled: !quickFilters.hasCompanyProperties,
        }
      }
      filter={<PickerFilters />}
      grouping={
        groupByOptions.length
          ? {
              value: toGroupValue(groupByKey),
              defaultValue: resetToEmpty
                ? fallbackGroupByKey
                : toGroupValue(initialGroupByKey),
              options: groupByOptions,
              allowNone: allowNoneGrouping,
              onChange: setGroupByKey,
            }
          : undefined
      }
      sorting={
        sortOptions.length
          ? {
              value: { key: sortKey, order: sortOrder },
              defaultValue: resetToEmpty
                ? { key: null }
                : { key: initialSortKey, order: initialSortOrder },
              options: sortOptions,
              onChange: value => setSort(value.key, value.order),
            }
          : undefined
      }
    />
  )
}

export default PickerToolbar
